var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fileSharing"}},[_vm._v(" 文件详情 弹框详情的内容 文件分享 ")])}
var staticRenderFns = []

export { render, staticRenderFns }